import FW from '../fw/fw';


export default class Sharing {

  #rmp;
  #filteredSharingNetworks = [];
  #sharingSocialContainer = FW.createElement('div', 'rmp-sharing-social');

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get filteredSharingNetworks() {
    return this.#filteredSharingNetworks;
  }

  static #filter(sharingNetworks) {
    const allowedNetworks = [
      'facebook',
      'x',
      'twitter',
      'linkedin',
      'reddit',
      'whatsapp',
      'email'
    ];
    const indexToRemove = [];
    sharingNetworks.forEach((sharingNetwork, index) => {
      if (allowedNetworks.indexOf(sharingNetwork) === -1) {
        indexToRemove.push(index);
      }
    });
    if (indexToRemove.length > 0) {
      for (let i = indexToRemove.length - 1; i >= 0; i--) {
        sharingNetworks.splice(indexToRemove[i], 1);
      }
    }
    return sharingNetworks;
  }

  static #onClickCopy(event) {
    const thisButton = event.target;
    const text = thisButton.parentNode.querySelector('input');
    if (text) {
      /* Select the text field */
      text.select();
      text.setSelectionRange(0, 99999); /*For mobile devices*/
      /* Copy the text inside the text field */
      document.execCommand('copy');
    }
  }

  #appendFacebook() {
    const facebookIcon = FW.createElement(
      'a',
      'rmp-button rmp-i rmp-i-facebook rmp-sharing-social-icons',
      null,
      null
    );
    facebookIcon.setAttribute('target', '_blank');
    facebookIcon.setAttribute('href', 'https://www.facebook.com/sharer/sharer.php?u=' +
      encodeURIComponent(this.#rmp.sharingUrl));
    this.#rmp.rmpAccessible.button(facebookIcon, 'Facebook');
    this.#sharingSocialContainer.appendChild(facebookIcon);
  }

  #appendTwitter() {
    const twitterIcon = FW.createElement(
      'a',
      'rmp-button rmp-i rmp-i-x rmp-sharing-social-icons',
      null,
      null
    );
    twitterIcon.setAttribute('target', '_blank');
    twitterIcon.setAttribute('href', 'https://x.com/share?url=' +
      encodeURIComponent(this.#rmp.sharingUrl));
    this.#rmp.rmpAccessible.button(twitterIcon, 'X');
    this.#sharingSocialContainer.appendChild(twitterIcon);
  }

  #appendLinkedin() {
    const linkedinIcon = FW.createElement(
      'a',
      'rmp-button rmp-i rmp-i-linkedin rmp-sharing-social-icons',
      null,
      null
    );
    linkedinIcon.setAttribute('target', '_blank');
    linkedinIcon.setAttribute('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' +
      encodeURIComponent(this.#rmp.sharingUrl));
    this.#rmp.rmpAccessible.button(linkedinIcon, 'LinkedIn');
    this.#sharingSocialContainer.appendChild(linkedinIcon);
  }

  #appendReddit() {
    const redditIcon = FW.createElement(
      'a',
      'rmp-button rmp-i rmp-i-reddit rmp-sharing-social-icons',
      null,
      null
    );
    redditIcon.setAttribute('target', '_blank');
    redditIcon.setAttribute('href', 'https://www.reddit.com/submit?url=' +
      encodeURIComponent(this.#rmp.sharingUrl));
    this.#rmp.rmpAccessible.button(redditIcon, 'Reddit');
    this.#sharingSocialContainer.appendChild(redditIcon);
  }

  #appendWhatsapp() {
    const whatsappIcon = FW.createElement(
      'a',
      'rmp-button rmp-i rmp-i-whatsapp rmp-sharing-social-icons',
      null,
      null
    );
    whatsappIcon.setAttribute('target', '_blank');
    whatsappIcon.setAttribute('href', 'whatsapp://send?text=' +
      encodeURIComponent(this.#rmp.sharingUrl));
    this.#rmp.rmpAccessible.button(whatsappIcon, 'WhatsApp');
    this.#sharingSocialContainer.appendChild(whatsappIcon);
  }

  #appendEmail() {
    const emailIcon = FW.createElement(
      'button',
      'rmp-button rmp-i rmp-i-email rmp-sharing-social-icons',
      null,
      null
    );
    emailIcon.addEventListener('click', () => {
      try {
        location.href = 'mailto:?body=' + encodeURIComponent(this.#rmp.sharingUrl);
      } catch (warning) {
        console.warn(warning);
      }
    });
    this.#rmp.rmpAccessible.button(emailIcon, 'Email', true);
    this.#sharingSocialContainer.appendChild(emailIcon);
  }

  #appendSharingLink() {
    const sharingLink = FW.createElement('div', 'rmp-sharing-link');
    const sharingLinkSpanIcon = FW.createElement('span', 'rmp-i rmp-i-link');
    sharingLink.appendChild(sharingLinkSpanIcon);
    const sharingLinkLabel = FW.createElement('label', '', this.#rmp.labels.hint.sharingLink);
    sharingLinkLabel.setAttribute('for', 'rmp-sharing-link-' + this.#rmp.id);
    sharingLink.appendChild(sharingLinkLabel);
    const sharingLinkInput = FW.createElement('input', 'rmp-sharing-input', '', this.#rmp.rtl);
    sharingLinkInput.setAttribute('id', 'rmp-sharing-link-' + this.#rmp.id);
    sharingLinkInput.setAttribute('aria-label', this.#rmp.labels.hint.sharingLink);
    sharingLinkInput.setAttribute('type', 'text');
    sharingLinkInput.setAttribute('value', this.#rmp.sharingUrl);
    sharingLink.appendChild(sharingLinkInput);
    const sharingLinkSpanCopy = FW.createElement('span', 'rmp-i rmp-i-copy');
    sharingLink.appendChild(sharingLinkSpanCopy);
    this.#rmp.dom.sharingOverlayLevelsArea.appendChild(sharingLink);
    sharingLinkSpanCopy.addEventListener('click', Sharing.#onClickCopy);
  }

  #appendSharingCode() {
    const sharingIframe = FW.createElement('div', 'rmp-sharing-code');
    const sharingCodeSpanIcon = FW.createElement('span', 'rmp-i rmp-i-code');
    sharingIframe.appendChild(sharingCodeSpanIcon);
    const sharingCodeLabel = FW.createElement('label', '', this.#rmp.labels.hint.sharingEmbedCode);
    sharingCodeLabel.setAttribute('for', 'rmp-sharing-code-' + this.#rmp.id);
    sharingIframe.appendChild(sharingCodeLabel);
    const sharingCodeInput = FW.createElement('input', 'rmp-sharing-input', '', this.#rmp.rtl);
    sharingCodeInput.setAttribute('id', 'rmp-sharing-code-' + this.#rmp.id);
    sharingCodeInput.setAttribute('aria-label', this.#rmp.labels.hint.sharingEmbedCode);
    sharingCodeInput.setAttribute('type', 'text');
    sharingIframe.appendChild(sharingCodeInput);
    const sharingCodeSpanCopy = FW.createElement('span', 'rmp-i rmp-i-copy');
    sharingIframe.appendChild(sharingCodeSpanCopy);
    this.#rmp.dom.sharingOverlayLevelsArea.appendChild(sharingIframe);
    sharingCodeInput.setAttribute('value', this.#rmp.sharingCode);
    sharingCodeSpanCopy.addEventListener('click', Sharing.#onClickCopy);
  }

  #appendOverlayUI() {
    // fb
    if (this.#filteredSharingNetworks.indexOf('facebook') > -1) {
      this.#appendFacebook();
    }

    // x
    if (this.#filteredSharingNetworks.indexOf('x') > -1 || this.#filteredSharingNetworks.indexOf('twitter') > -1) {
      this.#appendTwitter();
    }

    // linkedin
    if (this.#filteredSharingNetworks.indexOf('linkedin') > -1) {
      this.#appendLinkedin();
    }

    // reddit
    if (this.#filteredSharingNetworks.indexOf('reddit') > -1) {
      this.#appendReddit();
    }

    // whatsapp
    if (this.#filteredSharingNetworks.indexOf('whatsapp') > -1) {
      this.#appendWhatsapp();
    }

    // email
    if (this.#filteredSharingNetworks.indexOf('email') > -1) {
      this.#appendEmail();
    }

    this.#rmp.dom.sharingOverlayLevelsArea.appendChild(this.#sharingSocialContainer);

    // link sharing
    this.#appendSharingLink();

    // iframe sharing 
    if (this.#rmp.sharingCode !== '') {
      this.#appendSharingCode();
    }
  }

  init() {
    // filter sharing
    this.#filteredSharingNetworks = Sharing.#filter(this.#rmp.sharingNetworks);
    // append module 
    this.#rmp.rmpModuleManagement.appendToModuleBar('sharing');
    this.#rmp.rmpModuleManagement.appendOverlay('sharing');
    this.#appendOverlayUI();
  }

}
